<app-select [class.include-comparator]="true"
  [class.prefix-and-text]="!isMobile() && displayMode() === 'prefixAndText'" [class.text-only]="!isMobile() && displayMode() === 'textOnly'"
  [disabled]="disabled()" [displayMode]="isMobile() ? 'iconOnly' : displayMode()" [(ngModel)]="internalModel" (selectedValueChange)="onModelChange($event)">
  @if (!allowedSizes() || allowedSizes()!.includes(GearSizeType.All)) {
    <app-option [value]="GearSizeType.All" [text]="'All'" [imgUrl]="'/img/sizes/all.png'" [lte]="true">
    </app-option>
  }
  @if (!allowedSizes() || allowedSizes()!.includes(GearSizeType.MediumOnly)) {
    <app-option [value]="GearSizeType.MediumOnly" [text]="'2x3'" [imgUrl]="'/img/sizes/mediumonly.png'" [lte]="true">
    </app-option>
  }
  @if (!allowedSizes() || allowedSizes()!.includes(GearSizeType.SmallOnly)) {
    <app-option [value]="GearSizeType.SmallOnly" [text]="'1x4'" [imgUrl]="'/img/sizes/smallonly.png'" [lte]="true">
    </app-option>
  }
  @if (!allowedSizes() || allowedSizes()!.includes(GearSizeType.TwoByTwoOnly)) {
    <app-option [value]="GearSizeType.TwoByTwoOnly" [text]="'2x2'" [imgUrl]="'/img/sizes/twobytwoonly.png'" [lte]="true">
    </app-option>
  }
  @if (!allowedSizes() || allowedSizes()!.includes(GearSizeType.JewelleryOnly)) {
    <app-option [value]="GearSizeType.JewelleryOnly" [text]="'2x1'" [imgUrl]="'/img/sizes/jewelleryonly.png'" [eq]="true">
    </app-option>
  }
</app-select>
